
export const GET_CLUB_SETTINGS_REQUEST = 'GET_CLUB_SETTINGS_REQUEST';
export const GET_CLUB_SETTINGS_SUCCESS = 'GET_CLUB_SETTINGS_SUCCESS';
export const GET_CLUB_SETTINGS_FAILURE = 'GET_CLUB_SETTINGS_FAILURE';

export const CLUB_SETTINGS_UPDATE_REQUEST = 'CLUB_SETTINGS_UPDATE_REQUEST';
export const CLUB_SETTINGS_UPDATE_SUCCESS = 'CLUB_SETTINGS_UPDATE_SUCCESS';
export const CLUB_SETTINGS_UPDATE_FAIL = 'CLUB_SETTINGS_UPDATE_FAIL';